import { render, staticRenderFns } from "./DangerHiddenDetail.vue?vue&type=template&id=2340b175&scoped=true"
import script from "./DangerHiddenDetail.vue?vue&type=script&lang=js"
export * from "./DangerHiddenDetail.vue?vue&type=script&lang=js"
import style0 from "./DangerHiddenDetail.vue?vue&type=style&index=0&id=2340b175&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340b175",
  null
  
)

export default component.exports